'use client';

import * as React from 'react';
import { IconArrowUp } from 'icon/Arrows/arrow-up';
import { IconClock } from 'icon/Time/clock';
import { Label } from '../label';
import { TimePickerInput } from './time-picker-input';

interface TimePickerProps {
  date: Date | undefined;
  setDate: (date: Date | undefined) => void;
}

export function TimePicker({ date, setDate }: TimePickerProps) {
  const minuteRef = React.useRef<HTMLInputElement>(null);
  const hourRef = React.useRef<HTMLInputElement>(null);
  const secondRef = React.useRef<HTMLInputElement>(null);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-end gap-2 text-secondary">
        <div className="grid gap-1 text-center">
          <Label htmlFor="hours" className="text-xs">
            Hour
          </Label>
          <TimePickerInput
            picker="hours"
            date={date}
            setDate={setDate}
            ref={hourRef}
            onRightFocus={() => minuteRef.current?.focus()}
          />
        </div>
        <div className="grid gap-1 text-center">
          <Label htmlFor="minutes" className="text-xs">
            Min
          </Label>
          <TimePickerInput
            picker="minutes"
            date={date}
            setDate={setDate}
            ref={minuteRef}
            onLeftFocus={() => hourRef.current?.focus()}
            onRightFocus={() => secondRef.current?.focus()}
          />
        </div>
        <div className="grid gap-1 text-center">
          <Label htmlFor="seconds" className="text-xs">
            Sec
          </Label>
          <TimePickerInput
            picker="seconds"
            date={date}
            setDate={setDate}
            ref={secondRef}
            onLeftFocus={() => minuteRef.current?.focus()}
          />
        </div>
        <div className="flex h-10 items-center">
          <IconClock className="ml-2 h-4 w-4" />
        </div>
      </div>
      <div className="hidden items-center gap-1.5 text-tertiary sm:flex">
        <kbd className="rounded-sm border bg-secondary p-1">
          <IconArrowUp className="size-3" />
        </kbd>
        <kbd className="rounded-sm border bg-secondary p-1">
          <IconArrowUp className="size-3 rotate-180" />
        </kbd>
        <span className="ps-0.5 text-xs font-medium leading-none text-quaternary">
          Adjust
        </span>
      </div>
    </div>
  );
}
